export default {
  name: 'EeiregReport',
  props: {
    materialGroup: {
      default: null,
      type: String
    },
    isModal: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      loading: false,
      updating: false,
      fromPeriod: null,
      clientId: null,
      activeInfo: null,
      sentInfo: null
    }
  },
  computed: {
    canEdit () {
      return (this.clientId === null && this.ApiRequest.userHasPermission('edit-eeireg'))
    },
    toPeriod () {
      return this.BasicHelper.getNextDatePeriod(this.fromPeriod);
    },
    componentName () {
      if (this.isModal) {
        return 'b-modal';
      }
      return 'div';
    },
    requestPath () {
      let path = 'eeireg/form/' + this.materialGroup + '/' + this.fromPeriod;
      if (this.clientId) {
        path += '/' + this.clientId;
      }
      return path;
    },
    tableHeaders () {
      const headers = [{ key: 'placed_lv', editable: false }];
      if (this.materialGroup === 'VKP') {
        headers.push({ key: 'collected_lv', editable: true });
      } else {
        headers.push({ key: 'households', editable: true });
        headers.push({ key: 'not_households', editable: true });
        headers.push({ key: 'treated_lv', editable: true });
        headers.push({ key: 'treated_eu', editable: true });
        headers.push({ key: 'treated_outside_eu', editable: true });
        headers.push({ key: 'disposed', editable: true });
        headers.push({ key: 'recycled_lv', editable: true });
        headers.push({ key: 'recycled_eu', editable: true });
        headers.push({ key: 'recycled_outside_eu', editable: true });
        headers.push({ key: 'regenerated_lv', editable: true });
        headers.push({ key: 'regenerated_eu', editable: true });
        headers.push({ key: 'regenerated_outside_eu', editable: true });
      }
      return headers;
    },
    title () {
      if (this.clientId) {
        return this.$t('eeireg.report.client.title') + ': ' + this.BasicHelper.getDatePeriodRangeFormatted(this.fromPeriod, this.toPeriod);
      }
      return this.$t('eeireg.report.all.title') + ': ' + this.BasicHelper.getDatePeriodRangeFormatted(this.fromPeriod, this.toPeriod);
    }
  },
  methods: {
    getValueClass (item, header) {
      if (this.sentInfo[item.key] && this.sentInfo[item.key][header.key]) {
        if (parseFloat(item[header.key]) !== parseFloat(this.sentInfo[item.key][header.key])) {
          return 'text-error font-weight-bold';
        }
        return 'text-success'
      }
      return '';
    },
    setData (clientId, period) {
      this.fromPeriod = period;
      this.clientId = clientId;
      this.activeInfo = null;
      this.sentInfo = null;
      this.getTableData();
      if (this.isModal) {
        this.$refs['modal-window'].show();
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    },
    getTableData () {
      if (this.fromPeriod) {
        this.loading = true;
        const self = this;
        this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, [], function (response) {
          if (response.data) {
            self.activeInfo = response.data.active;
            self.sentInfo = response.data.sent;
          }
          self.loading = false;
        })
      }
    },
    save () {
      this.updating = true;
      const self = this;
      const reqData = this.BasicHelper.cloneObject(this.activeInfo);
      this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_POST, { form: reqData }, function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
        } else {
          self.activeInfo = response.data;
          if (self.isModal) {
            self.close();
          }
        }
        self.updating = false;
      })
    }
  }
}
